import { ApplicationConfig, EnvironmentProviders, makeEnvironmentProviders, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    IncludeBearerTokenCondition, includeBearerTokenInterceptor, provideKeycloak } from 'keycloak-angular';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { indexedDbNameToken, IndexedDbName, envToken } from 'lib';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /^(.*\/api\/v1\/.*)?$/i,
    bearerPrefix: 'Bearer'
});

function provideEnvironment(): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: envToken, useValue: environment }]);
}

export function getAppConfig(keycloakRealm: string): ApplicationConfig {
    return {
        providers: [
            provideHttpClient(withInterceptorsFromDi()),
            provideKeycloak({
                config: {
                    ...environment.keycloakConfig,
                    realm: keycloakRealm
                },
                initOptions: {
                    onLoad: 'check-sso',
                    silentCheckSsoRedirectUri:
                        window.location.origin + '/assets/silent-check-sso.html',
                    checkLoginIframe: true,
                    pkceMethod: 'S256'
                }
            }),
            {
                provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
                useValue: [urlCondition]
            },
            provideZoneChangeDetection({ eventCoalescing: true }),
            provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
            provideRouter(routes),
            provideAnimations(),
            provideToastr(),
            provideHttpClient(),
            providePrimeNG({
                theme: {
                    preset: Aura,
                    options: {
                        prefix: 'p',
                        darkModeSelector: 'none',
                        cssLayer: false
                    }
                }
            }),
            provideEnvironment(),
            {
                provide: indexedDbNameToken,
                useValue: IndexedDbName.ORG_GROUP_ADMIN
            }
        ]
    };
}

